module.exports = __webpack_public_path__ + "img/shu4.266a3322.png";